import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ChangeDetectorRef, ElementRef, ChangeDetectionStrategy } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { PHBHPLayoutPackageService } from "../ph-bhp-layout-package.service";
import { SelectionModel } from "@angular/cdk/collections";


@Component({
  selector: "bd-light-table",
  templateUrl: "./light-table.component.html",
  styleUrls: ["./light-table.component.css"],
})
export class LightTableComponent implements OnInit {
  @Input() gridData;
  @Input() fields;
  @Input() pageInfo: any;
  @Input() pagesSizeOptions: any[] = [10, 20, 50, 100];
  @Input() actions: any[];
  @Input() showFirstLastButtons: boolean = true;
  @Input() addNewRow: boolean = false;
  @Input() addNewRowButton: boolean = false;
  @Input() customButton: any;
  @Input() migrationButton: any;
  @Input() gridEditable = false;
  @Input() classTable: string;
  @Input() isRowEditable: (row: any) => boolean = () => this.gridEditable;
  @Input() isRowDeletable: (row: any) => boolean = () => this.gridEditable;
  @Input() showPaginator: boolean = true;
  @Input() inlineAddRow: boolean = false;
  @Input() isSelectable: boolean = false;
  @Input() hasSubtitles: boolean = false;
  @Input() isEvaluationTable: boolean = false;
  @Input() zeroIfEmpty: boolean = false;
  @Input() NAifEmpty: boolean = false;
  @Input() multiSelectText: string = '';
  @Output() handlerData = new EventEmitter();
  @Output() removeLink = new EventEmitter();
  @Output() addNewRowCallback = new EventEmitter();
  @Input() chartType: string = '';
  @Input() defaultId = null;
  @Input() newQuestionnaireButton: boolean = false;
  @Input() newQuestionnaireAction: any;
  @Input() defaultColumnTable: boolean = false;

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild('container', { static: true }) container: ElementRef;

  hasActions: boolean;
  fieldsKeys: any[];
  page: number;
  pageSize: number = this.pagesSizeOptions[0];
  initPage: number;
  endPage: number;
  totalSize: number;
  viewPages: any[];
  rangeLabel: string;
  totalPages: number;
  dataSource: any;
  editRowIndex: number = -1;
  editItem: any;
  isNew: boolean = false;
  editMode: boolean = false;
  loading: boolean = false;
  selection = new SelectionModel<any>(true, []);
  columnGroups = new Map<string, string[]>();
  multiColumnGroups = new Map<string, string[]>();
  groupHeaders: string[] = [];
  multiHeaders: string[] = [];

  constructor(
    private layoutService: PHBHPLayoutPackageService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {

    if (this.classTable) {
      this.container.nativeElement.classList.add(this.classTable);
    }
    if (this.gridData) {
      this.totalSize = this.gridData.length;
      this.page = 0;
      this.totalPages = Math.ceil(this.totalSize / 10) - 1;
      this.layoutService.lang.asObservable().subscribe((lang) => {
        this.layoutService.showLoader = true
      });
      this.updateGrid();
    }
  }

  ngOnChanges() {
    if (this.gridData) {
      this.totalSize = this.gridData.length;
      this.totalPages = Math.ceil(this.totalSize / (+this.pageSize)) - 1;
      this.page = 0;
      this.updateGrid();
      this.prepareColumnGroups();
    }
  }

  prepareColumnGroups() {
    const groupNames = new Set<string>(this.fields.filter(f => f.group).map(f => f.group as string));

    groupNames.forEach(groupName => {
      const groupColumns = this.fields.filter(f => f.group === groupName).map(f => f.field);
      this.columnGroups.set(groupName, groupColumns);

    });

    this.groupHeaders = Array.from(groupNames).map(name => 'group-' + name);
    this.groupHeaders = [' ', ...this.groupHeaders];


    const multiNames = new Set<string>(this.fields.filter(f => f.multiName && f.group).map(f => `${f.multiName}-${f.group}`));
    const multiGroups = [];
    multiNames.forEach(multiGroupName => {
      const [multiName, group] = multiGroupName.split('-');
      const multiColumns = this.fields.filter(f => f.multiName === multiName && f.group === group).map(f => f.field);
      this.multiColumnGroups.set(multiName, multiColumns);
      multiGroups.push(multiName);
    });

    this.multiHeaders = Array.from(multiGroups).map(name => 'multi-' + name);
    this.multiHeaders = [' ', ...this.multiHeaders];

  }

  changePageSize(pageNumber) {
    this.pageSize = pageNumber;
    this.totalSize = this.gridData.length;
    this.totalPages = Math.ceil(this.totalSize / (+this.pageSize)) - 1;
    this.page = 0;
    this.updateGrid();
  }

  updateGrid(event?: Event) {

    this.loading = true;
    if (this.editMode) {
      this.cancel(true)
    }
    this.fieldsKeys = this.fields.map((item) => item['field']);
    this.hasActions = this.actions ? true : false;
    if (this.hasActions) {
      this.fieldsKeys.push('actions');
    }
    if (this.isSelectable) {
      this.fieldsKeys.unshift('select');
    }
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.paginator = this.paginator;

    this.pageSize = (+this.pageSize);
    let initPage = 0;
    let endPage = 0;
    let startPagination = this.page - 2;
    let endPagination = this.page + 2;

    if (this.totalSize <= 10) {
      initPage = 1;
      endPage = this.totalSize;
      this.dataSource = new MatTableDataSource(this.gridData);
    } else {
      if (this.page == 0) {
        initPage = 1;
        endPage = this.pageSize;
      } else {
        initPage = (this.page * this.pageSize) + 1;
        endPage = (this.page * this.pageSize) + this.pageSize;
      }
      if (endPage > this.totalSize) endPage = this.totalSize;
      this.dataSource = new MatTableDataSource(this.gridData.slice(initPage - 1, endPage));
    }

    this.viewPages = [];
    if (this.totalPages > 5) {

      if (startPagination < 0) {
        startPagination = 0;
        endPagination = 4;
      }
      if (endPagination > this.totalPages) {
        startPagination = this.totalPages - 4;
        endPagination = this.totalPages;
      }
      for (let i = startPagination; i <= endPagination; i++) {
        this.viewPages.push(i);
      }
    } else {
      for (let i = 0; i <= this.totalPages; i++) {
        this.viewPages.push(i);
      }
    }

    this.rangeLabel = `${initPage} - ${endPage} / ${this.totalSize}`;
    setTimeout(() => {
      this.loading = false;
    }, 250);

  }

  selectPage(page) {
    this.page = page;
    this.updateGrid();
  }

  firstPage() {
    this.page = 0;
    this.updateGrid();
  }

  lastPage() {
    this.page = this.totalPages;
    this.updateGrid();
  }

  nextPage() {
    this.page++;
    if (this.page > this.totalPages) this.page = this.totalPages;
    this.updateGrid();
  }

  previousPage() {
    this.page--;
    if (this.page < 0) this.page = 0;
    this.updateGrid();
  }

  saveRow(event, row, rowIndex) {
    this.gridData[rowIndex] = this.editItem;
    let validRow = true;
    for (let field of this.fields) {
      if (field.editTemplate && field.editTemplate.validator) {
        if (!field.editTemplate.validator(this.editItem)) {
          validRow = false;
          break;
        }
      }
    }
    if (!validRow) {
      return;
    }
    this.handlerData.emit({
      handler: "saveHandler",
      rowIndex,
      formGroup: {},
      isNew: this.isNew,
      dataItem: this.editItem,
    });
    this.isNew = false;
    this.updateGrid();
    this.editRowIndex = -1;
  }

  editRow(event, row, rowindex) {
    this.editMode = true;
    this.editRowIndex = rowindex;
    this.editItem = Object.assign({}, row);
  }

  changeValue(event, row, fieldId, type, fieldText?) {
    this.editItem[fieldId] = event;

    if (type == 'dropdown') {
      // for dropdown type
      let field = this.fields.find(item => item.field === fieldText);
      let dataField = field.editTemplate.data.find(item => item[fieldId] == event)
      this.editItem[fieldText] = dataField[fieldText];
    }

    if (type == 'checkbox') {
      // for checkbox type
      this.editItem[fieldId] = event;
    }
  }

  changeValueRadio(id: string) {
    this.defaultId = id;
    this.handlerData.emit({
      type: 'default',
      defaultId: id
    });
  }

  addRow() {
    if (this.addNewRowCallback && this.addNewRowCallback.observers.length > 0) {
      this.addNewRowCallback.emit();
    } else {
      if (!this.isNew) {
        this.gridData.unshift({});
        this.editRowIndex = 0;
        this.editItem = {};
        this.fields.forEach((field, index) => {
          if (field && field.editTemplate && field.editTemplate.type == 'dropdown' && field.editTemplate.defaultValue) {
            this.changeValue(field.editTemplate.defaultValue, 0, field.editTemplate.valueField, 'dropdown', field.editTemplate.textField);
          }
        });
        this.isNew = true;
        this.updateGrid();
      }
    }
  }

  cancel(fromPagination?) {
    this.editRowIndex = -1;
    this.editItem = null;
    this.editMode = false;
    if (this.isNew) {
      this.gridData.shift();
      this.isNew = false;
      if (!fromPagination) {
        this.updateGrid();
      }
    }
  }

  brokeLink(dataItem) {
    this.removeLink.emit(dataItem);
  }
  hasRowLink(row) {
    return this.gridEditable && row.webkessWardName && this.layoutService.institutionWebkess;
  }

  trackDataSource(index, item) {
    return item;
  }

  allSelected: boolean = false;

  toggleMasterSelection() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.gridData.forEach(row => this.selection.select(row));
    this.allSelected = !this.allSelected;
  }

  toggleIndividualSelection(row) {
    this.selection.toggle(row);
  }

  isAllSelected(): boolean {
    return this.allSelected;
  }

  getSelectedRows() {
    return this.selection.selected;
  }

  clearSelection() {
    this.allSelected = false;
    this.selection.clear();
  }

  showAction(item, row) {
    if (!item.canDisable) return true;
    return !item.canDisable(row);
  }

  getHeaderText(index: number, element: HTMLElement): string {
    if (index === 0) {
      if (element.parentElement.classList.contains('filters-row')) {
        return this.chartType !== '' ? (this.chartType === 'filter' ? 'EVALUATION.FILTER' : 'DASHBOARD.BENCHMARK') : '';
      } else if (element.parentElement.classList.contains('multi-row')) {
        return this.multiSelectText;
      }
    }
    return '';
  }

  isDefault(id) {
    return this.defaultId === id;
  }
}
